import { svgToDataURL } from 'common/utils/index';

import { CAR_HEIGHT, CAR_WIDTH } from 'components/Map/constants/icons';
import { getPositionMarkerIcon } from './icons/getPositionMarkerIcon';

const ICONS = {
  positionMarker: () => ({
    url: svgToDataURL(getPositionMarkerIcon()),
    width: CAR_WIDTH,
    height: CAR_HEIGHT,
    anchorY: CAR_HEIGHT / 2,
  }),
};

export const getIcon = () => {
  return ICONS['positionMarker']();
};
